import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import DraftQuestionsView from '../components/exam_made_easy/draft_question_view/DraftQuestionsView';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
  } from "react-device-detect";
  

const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        exams{
            id
            exam
            exam_subjects{
                subject_id
                no_of_questions
            }
            avg_question_time
        }
        globalBranches{
            id
            branch_name
        }
        classes{
            id
            class
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
        }
        subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                    # practice_percentage
                }
                class
            }
            state_chapters{
                id
                chapter
                exam_id
                state_topics{
                    id
                    topic
                }
                class
            }
        }
        questionTypes{
            id
            questiontype
        }
        questionTheory{
            id
            question_theory
        }
        complexity{
            id
            complexity
            
        }
    }
}

`;


const FETCH_SAVED_PAPERS = gql`
  query($institution_id: Int!) {
    getSavedPapers(institution_id: $institution_id) {
        id
        name
        exam_type
        no_of_sets
        start_time
        end_time
        is_completed
        class
        section
        branch
        type
        class_id
        exam_model_id
        is_partexam
        mains_2021
        timestamp
        estatus
        sub_exam_type
        total_question_count
        exam_questions{
            id
            subject
            chapter
            topic
            question
            qtype
            option1
            option2
            option3
            option4
            chapter_name
            topic_name
            complexity
            compquestion
            list1type
            list2type
            mat_question
            answer
            inputquestion
        }
    }
  }
`;


class ExamMadeEasyDraftQuestionView extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        const savedPapers = this.props.getSavedPapers;
        const loading2 = savedPapers.loading;
        const error2 = savedPapers.error;
        
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
      
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                    <SideNavbar onClick={() => this.menuToggler()} />
                </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                        <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
                            {
                            loading2 ?
                                    (
                                        <Container><Row className="my-3">
                                            <Col>
                                                <div class="spinner-border text-primary text-center loading-img-center"></div>
                                            </Col>
                                        </Row></Container>
                                    )
                                    :
                                    (
                                        <DraftQuestionsView
                                            globals={globals.globals}
                                            savedPapers={savedPapers.getSavedPapers}
                                        />

                                    )
                            }
                                
                        </div>
                    <Footer />
                </div>
            </div>
        );
    }
}




export default withRouter(
    compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "globals"
            }),
            graphql(FETCH_SAVED_PAPERS, {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    },
                    fetchPolicy:'cache-and-network',
                    nextFetchPolicy: 'cache-and-network',
                }),
                name: "getSavedPapers"
            }),
    )
        (ExamMadeEasyDraftQuestionView));